const React = require('react');
const RadioButtonGroup = require('components/RadioButtonGroup');
const RadioButton = require('components/RadioButton');
const FieldContext = require('./FieldContext');

module.exports = function RadioField(props) {

    const {
        field = {},
        fieldName = field.name
    } = props;

    const fieldController = FieldContext.useField(fieldName);
    const currentValue = fieldController.getValue();
    const options = field.options || [];
    const hasOptOut = Object.prototype.hasOwnProperty.call(field, 'optOutValue');
    const title = field.title || field.label;

    const selectedValue = currentValue !== null && currentValue !== undefined
        ? String(currentValue)
        : '';

    return <RadioButtonGroup
        label={title}
        labelId={`${field.name}-label`}
        valueSelected={selectedValue}
        onChange={(event) => {

            const rawValue = event.target.value;
            const matchingOption = options.find((opt) => String(opt.value) === rawValue);
            const nextValue = matchingOption ? matchingOption.value : rawValue;
            fieldController.setValue(nextValue, undefined, event);
        }}
    >
        {options.map((option) => (
            <RadioButton
                key={String(option.value)}
                value={String(option.value)}
                label={option.label}
            />
        ))}
        {hasOptOut && field.optOutLabel && (
            <RadioButton
                value={String(field.optOutValue)}
                label={field.optOutLabel}
            />
        )}
    </RadioButtonGroup>;
};
